import _import from './_import.js';

export default [
	// 常见问题
	{
	  path: 'service/faq',
	  component: _import('service/faq'),
      children: [{
	    path: ':type',
        component: _import('service/faq')
      }]
	},
	// 操作手册
	{
	  path: 'service/manual',
	  component: _import('service/manual'),
      children: [{
        path: ':type',
        component: _import('service/manual')
      }]
	},
	// 在线支持
	{
	  path: 'service/support',
	  component: _import('service/support')
	},
	// 覆盖区域
	{
	  path: 'service/coverage',
	  component: _import('service/coverage')
	},
	// 企业方案
	{
	  path: 'service/enterprise',
	  component: _import('service/enterprise')
	},
	// 保养维修
	{
	  path: 'service/maintenance',
	  component: _import('service/maintenance')
	},
	// 安全措施
	{
	  path: 'service/safety_measures',
	  component: _import('service/safety_measures')
	},
];


// WEBPACK FOOTER //
// ./src/router/service.js